import SET_LOADER from "../actionTypes/loader_set";

const initialState = {
  isLoading: false,
};

const loaderSet = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADER.LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
};

export default loaderSet;
